import { BreadcrumbJsonLd } from 'next-seo';
import PropTypes from 'prop-types';

import {
  toAbsoluteLink,
  toStoreCouponsLink,
  toStoreOffersLink,
} from 'lib/links';
import placeholder from 'lib/placeholder';

import APP from 'constants/app';
import LINKS from 'constants/links';

const StoreSchema = ({ isOfferPage, storeName, storeSlug }) => (
  <>
    <BreadcrumbJsonLd
      itemListElements={[
        {
          position: 1,
          name: placeholder('breadcrumbs.app'),
          item: APP.URL,
        },
        {
          position: 2,
          name: isOfferPage
            ? placeholder('breadcrumbs.stores')
            : placeholder('breadcrumbs.coupons'),
          item: toAbsoluteLink(LINKS.STORES),
        },
        {
          position: 3,
          name: storeName,
          item: isOfferPage
            ? toAbsoluteLink(toStoreOffersLink(storeSlug))
            : toAbsoluteLink(toStoreCouponsLink(storeSlug)),
        },
      ]}
    />
  </>
);

StoreSchema.propTypes = {
  isOfferPage: PropTypes.bool.isRequired,
  storeName: PropTypes.string.isRequired,
  storeSlug: PropTypes.string.isRequired,
};

export default StoreSchema;
